export enum EmailProvider {
  Gmail = 'gmail',
  Yandex = 'yandex',
  Mail = 'mail',
  Rambler = 'rambler',
  ICloud = 'icloud',
  Outlook = 'outlook',
}

export interface ProviderConfig {
  icon: JSX.Element;
  name: string;
  url: string;
}
